"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mix = void 0;
const get_mixables_1 = require("./get-mixables");
require("reflect-metadata");
function mix(client, mixins) {
    mixins.forEach(mixin => Object.defineProperties(client.prototype, (0, get_mixables_1.getMixables)(client, mixin)));
}
exports.mix = mix;
